import { ReactNode } from 'react'
import { NavLink as BaseNavLink } from 'react-router'

interface Props {
  to: string
  children: ReactNode | string
}

export const NavLink = ({ to, children }: Props) => {
  return (
    <>
      <BaseNavLink
        to={to}
        className={
          ({ isActive }) => isActive
            ? 'border-b border-zinc-900 dark:border-white'
            : 'border-b border-white dark:border-zinc-900'
        }
        end
      >
        { children }
      </BaseNavLink>
    </>
  )
}
